import { Link } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mt-6">Pagina non trovata</h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm md:text-base text-foreground-500">Questa pagina non è stata ancora generata.</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full bg-primary-500 text-white font-label text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
        >
          Torna alla Home
          <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
        </Link>
      </div>
    </div>
  );
}